import { Card, Stack, Title, Code, Group, Button, Text } from '@repletoryreach/sdk-ui';
import { notifySuccess } from '@repletoryreach/sdk-ui/notifications';
import type { flows as flowsNs } from '@repletoryreach/sdk-api';
import { useT } from '../../../../i18n/I18nProvider';

type Flow = NonNullable<Awaited<ReturnType<typeof flowsNs.getFlow>>['data']>;

const MUTED = 'var(--rr-color-text-muted, #94a3b8)';

export function DefinitionTab({ flow }: { flow: Flow }) {
  const t = useT();
  const pretty = JSON.stringify(flow.definition, null, 2);
  return (
    <Card withBorder>
      <Stack gap="sm">
        <Group justify="space-between" align="baseline">
          <Title order={4}>{t('flows.drawer.definition')}</Title>
          <Button
            size="xs"
            variant="outline"
            onClick={() => {
              void navigator.clipboard.writeText(pretty);
              notifySuccess(t('flows.view.definition.copied'), t('toast.copied'));
            }}
          >
            Copy
          </Button>
        </Group>
        <Text fz="xs" c={MUTED}>
          {t('flows.view.definition.hint', { open: t('flows.builder.open') })}
        </Text>
        <Code block>{pretty}</Code>
      </Stack>
    </Card>
  );
}
